import { useCallback, useMemo, useState } from 'react';
import { nanoid } from 'nanoid';

import { NotificationsContainer } from '@/shared/ui/Notifications/NotificationsContainer';

import { INotification, INotificationProviderProps } from './types';
import { notificationContext } from './useNotifications';

export const NotificationsProvider = ({
  children,
}: INotificationProviderProps) => {
  const [notifications, setNotifications] = useState<INotification[]>([]);

  const addNotification = useCallback((notification: INotification) => {
    setNotifications((prevState) => [
      ...prevState,
      {
        ...notification,
        id: notification.id ? notification.id : nanoid(),
      },
    ]);
  }, []);

  const deleteNotification = useCallback((deleteId: string | number) => {
    setNotifications((prevState) =>
      prevState.filter((notification) => notification.id !== deleteId)
    );
  }, []);

  const value = useMemo(
    () => ({ addNotification, deleteNotification }),
    [addNotification, deleteNotification]
  );

  return (
    <notificationContext.Provider value={value}>
      {children}
      <NotificationsContainer
        notifications={notifications}
        deleteNotification={deleteNotification}
      />
    </notificationContext.Provider>
  );
};
